module.exports = __webpack_public_path__ + "media/images/icons/man-luggage-d66f1b4bb987911c9e9f1c45bce93398.svg";